import Image from "next/image";
import IconTooltip from "@/components/IconTooltip";
import {capitalize} from "@/lib/util";

export default function ThingToDoItem({thing, parkName}) {
    //console.log(thing)

    // Filter out current park name from tags
    let tags = thing.tags.reduce(function(result, el) {
        if (el !== parkName) {
            result.push(capitalize(el))
        }
        return result;
    }, []);

    return (
        <article key={thing.id} className={`flex max-sm:flex-wrap sm:flex-nowrap mb-6`}>
            <a href={thing.url} target="_blank" rel="noreferrer" className={`block max-md:w-full md:w-[145px] md:h-[145px] aspect-square relative`}>
                <Image src={thing.images[0].url} width={200} height={200} alt={thing.images[0].altText} className={`rounded object-cover h-full w-full`}/>
            </a>
            <div className={`mt-3 sm:mt-0 sm:pl-5`}>
                <a href={thing.url} target="_blank" rel="noreferrer" className={`block font-bold mb-2`}>
                    {thing.title}
                </a>
                {thing.shortDescription ?
                    <p className={`text-xs mb-2`}>
                        {thing.shortDescription.substring(0, 180)}&hellip;
                        <a href={thing.url} target="_blank" rel="noreferrer"> Read more  <i className="fa-solid fa-chevron-right text-xxs"></i></a>
                    </p>
                : null}

                <div className={`flex`}>
                    {thing.duration ?
                        <p className={`text-xs mb-2`}>Duration {thing.duration}</p>
                        : null}

                    {thing.location ?
                        <p className={`text-xs mb-2 ${thing.duration ? 'ml-4' : ''}`}>Location: {thing.location}</p>
                        : null}
                </div>

                <div className={`flex content-center justify-start items-center mb-3`}>
                    {thing.doFeesApply ?
                        <p className={``}>
                            <IconTooltip icon="money-check-dollar" name="Fees apply" size={`text-xl`} color={`text-brown-300`} tooltipClassNames={`bg-beige-30`}/>
                        </p>
                    : null}

                    {thing.isReservationRequired === "false" ?
                        <IconTooltip icon="calendar-minus" name="No reservation required" size={`text-xl`} color={`text-brown-300`} classNames={`ml-2`} tooltipClassNames={`bg-beige-30`} />
                        : null}

                    {thing.isReservationRequired === "true" ?
                        <IconTooltip icon="calendar-plus" name="Reservations required" size={`text-xl`} color={`text-brown-300`} classNames={`ml-2`} tooltipClassNames={`bg-beige-30`} />
                        : null}
                </div>

                <ul className={`flex`}>
                     {thing?.activities?.map((activity) =>
                        <li key={activity.id}>
                            <p className={`text-xxs py-1 pb-1 px-3 bg-beige-30 rounded-full mr-2`}>{activity.name}</p>
                        </li>
                    )}
                </ul>
            </div>
        </article>
    )
}